export const AUTH_TOKEN_KEY = 'access_token';
export const AUTH_ROLE_KEY = 'activeRole';

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

export const setAuthToken = (token) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const getActiveRole = () => localStorage.getItem(AUTH_ROLE_KEY) || sessionStorage.getItem(AUTH_ROLE_KEY);

export const getSessionRole = () => sessionStorage.getItem(AUTH_ROLE_KEY);

export const setActiveRole = (role, persist = true) => {
  if (role) {
    sessionStorage.setItem(AUTH_ROLE_KEY, role);
    if (persist) {
      localStorage.setItem(AUTH_ROLE_KEY, role);
    } else {
      localStorage.removeItem(AUTH_ROLE_KEY);
    }
  } else {
    localStorage.removeItem(AUTH_ROLE_KEY);
    sessionStorage.removeItem(AUTH_ROLE_KEY);
  }
};

export const clearActiveRole = () => {
  localStorage.removeItem(AUTH_ROLE_KEY);
  sessionStorage.removeItem(AUTH_ROLE_KEY);
};

export const clearAuthState = () => {
  clearAuthToken();
  clearActiveRole();
};